import { useGLTF, useTexture } from '@react-three/drei'

export default function Crashpad() {
    const { nodes } = useGLTF('./models/map/crashpad.glb')
    const texture = useTexture('./textures/map/crashpad.jpg')
    texture.flipY = false

    return (
        <mesh 
            geometry={nodes.crashpad.geometry} 
            onClick={ (event) => event.stopPropagation() }
            onPointerEnter={ (event) => event.stopPropagation()}
        >
            <meshBasicMaterial map={texture} />
        </mesh>
    )
}
